import { Expose, Type } from 'class-transformer'

import { Sku } from './Sku'

export class BatchSku {
  @Type(() => Sku)
  sku?: Sku

  @Expose({ name: 'num_units' })
  numUnits: number = 0

  @Expose({ name: 'num_available' })
  numAvailable: number = 0

  @Expose({ name: 'num_reserved' })
  numReserved: number = 0

  @Expose({ name: 'num_awaiting_shipment' })
  numAwaitingShipment: number = 0

  get product() {
    return this.sku?.product
  }
}
